<template>
<div class="pt_scroll">
  <div class="pt_scroll_listwrap">
    <div class="pt_scroll_list" id="list" :class="{anim:animate}">
      <CollageItem v-for="(item,index) in noticeList" :item="item" :key="index" v-on:gotoJoinGroup="gotoJoinGroup"/>
    </div>
  </div>
  
</div>
</template>
<script>
import CollageItem from "./CollageItem"

export default {
  name: '',
  components:{
    CollageItem
  },
  props: {
    noticeList: {
      type: Array,
      default: function(){
        return []
      }
    }
  },
  data () {
    return {
      title: '',
      animate:false,
      
    }
  },
  mounted(){
    if(this.noticeList.length>3){
        this.ptScrollUp();
      }
  },
  methods: {
    ptScrollUp() {
      var dom = document.getElementById("list");
      let _field = null
			var timer = setTimeout(function() {
				_field = dom.firstElementChild;
				_field.style.marginTop = "-48px";
				clearTimeout(timer);
      }, 1000)
      setInterval(function() {
				_field = dom.firstElementChild;
				_field.style.marginTop = "0px";
				dom.appendChild(_field);
				var _field = dom.firstElementChild
				_field.style.marginTop = "-48px";
			}, 3000)
    },
    gotoJoinGroup(group){
      this.$emit("gotoJoinGroup",group)
    }
  }
}
</script>
<style scoped lang='less'>
.pt_scroll{
  // height: 3.0933rem;
  padding: 0.2667rem 0.32rem;
  box-sizing: border-box;
}
.pt_scroll_listwrap{
  min-height: 1.28rem;
  max-height: 2.56rem;
  overflow: hidden;
}
.anim{
    transition: all 0.5s;
    margin-top: -1.28rem;//高度等于行高
}
.pt_scroll_list{
  -webkit-animation: 10s rowup linear infinite normal;
    animation: 10s rowup linear infinite normal;
}


</style>